import { useState } from 'react';
import { NavLink, generatePath, useMatch } from 'react-router-dom';
import {
  IconUser,
  IconUp,
  IconDown,
  ClickOutsideDetector,
  IconExpand,
} from '@ui/src';
import { AddCompanyOfficialTypes } from '../types';

import ROUTES from '../../../routes';

import cn from './overview.module.css';

const AddCompanyOfficial = ({ customerId }: AddCompanyOfficialTypes) => {
  const [menuVisible, setMenuVisible] = useState(false);

  const transactionMatch = useMatch(
    generatePath(ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_COMPANY_OFFICIAL, {
      customerId: customerId as string,
    }),
  );

  return (
    <div className={cn.addCompanyOfficialBlock}>
      <div className={cn.addCompanyOfficialWrapper}>
        <ClickOutsideDetector setOptionsListVisible={setMenuVisible}>
          <>
            <button
              type="button"
              className={`${cn.addCompanyOfficialButton} ${
                menuVisible ? cn.addCompanyOfficialButtonActive : ''
              }`}
              onClick={() => setMenuVisible(!menuVisible)}
            >
              Add Company Official
              {menuVisible ? <IconUp /> : <IconDown />}
            </button>
            {menuVisible && (
              <ul className={cn.addCompanyOfficialMenu}>
                <li>
                  <NavLink
                    to={generatePath(
                      transactionMatch
                        ? ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_SELECT_COMPANY_OFFICIAL
                        : ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_SELECT_COMPANY_OFFICIAL,
                      { customerId: customerId as string },
                    )}
                  >
                    Select from Customers
                    <IconUser />
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={generatePath(
                      transactionMatch
                        ? ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_ADD_COMPANY_OFFICIAL
                        : ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_ADD_COMPANY_OFFICIAL,
                      { customerId: customerId as string },
                    )}
                  >
                    Create new Customer
                    <IconExpand />
                  </NavLink>
                </li>
              </ul>
            )}
          </>
        </ClickOutsideDetector>
      </div>
    </div>
  );
};

export default AddCompanyOfficial;
